import { queryOptions } from "@tanstack/react-query";
import {
  getOrganizationAthleteMetrics,
  getOrganizationAthleteMetricSeries,
  addOrganizationAthleteMeasurements,
  type Api,
} from "api-client";
import { assert } from "utils";

import { type MetricsRepository } from "./MetricsRepository";

export function createOrganizationMetricsRepository(
  organizationId: string,
): MetricsRepository {
  return {
    queryKey: ["organizations", organizationId, "athlete-metrics"],
    summaryOptions(athleteId) {
      return queryOptions<Api.GetMetricsSummary.Output.Self>({
        queryKey: [
          "organizations",
          organizationId,
          "athlete-metrics",
          athleteId,
        ],
        async queryFn() {
          return (
            await getOrganizationAthleteMetrics({
              path: { organizationId, athleteId },
            })
          ).data.data;
        },
      });
    },
    seriesOptions(input) {
      return queryOptions<Api.GetMetricSeries.Output.Self>({
        queryKey: [
          "organizations",
          organizationId,
          "athlete-metrics",
          input.athleteId,
          "series",
          input.metricId,
          input.view,
        ],
        async queryFn() {
          assert(input.athleteId, "Athlete ID required");
          return (
            await getOrganizationAthleteMetricSeries({
              path: {
                organizationId,
                athleteId: input.athleteId,
                metricId: input.metricId,
              },
              query: { view: input.view },
            })
          ).data.data;
        },
      });
    },
    async addMeasurement(input) {
      return (
        await addOrganizationAthleteMeasurements({
          path: { organizationId, athleteId: input.athleteId },
          body: { metrics: input.metrics },
        })
      ).data.data;
    },
  };
}
